/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './ExpandableNavLink.scss';

const ExpandableNavLink = ({
  children,
  content,
}) => {
  const [subMenuClasses, setSubMenuClasses] = useState('hidden');
  return (
    <li
      onClick={() => {
        setSubMenuClasses('visible');
      }}
      // onBlur={() => {
      // setSubMenuClasses('hidden');
      // }}
      // onMouseLeave={() => {
      //   setSubMenuClasses('hidden');
      // }}
      role="presentation"
    >
      <a href="#" className="nav-link">{content}</a>
      <ul className={`sub-menu ${subMenuClasses}`}>
        {children}
      </ul>
    </li>
  );
};

ExpandableNavLink.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.string.isRequired,
};

export default ExpandableNavLink;
